import { useState, useEffect, useCallback } from "react";
import { CustomList } from "../CustomDepartment/CustomList";
import {
  createEffort,
  getEfforts,
  updateDepartment,
} from "../../../../../apis/Business/DepartmentEffortApi";
import ambitionIcon from "../../../../../assets/shapes_svg/ambition/ambition-dept-icon.svg";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import { ambitionDeptKey } from "../../../../../apis/ApiKey/AmbitionDepartmentKey";
import { Link } from "react-router-dom";
import { useUserAccess } from "../../../../../components/WriteAccessContext";

export const Department = ({ department, onUpdateDepartment }) => {
  const [efforts, setEfforts] = useState([]);
  const [newEffort, setNewEffort] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(department.name);
  const { triggerInvalidate, invalidateKey, resetKey } = useInvalidateQuery();
  const { createEfforts } = ambitionDeptKey;
  const [year, setYear] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setYear(params.get("year"));

    // Optional: Add a listener for URL changes
    const handleUrlChange = () => {
      const params = new URLSearchParams(window.location.search);
      setYear(params.get("year"));
    };

    window.addEventListener("popstate", handleUrlChange);
    return () => window.removeEventListener("popstate", handleUrlChange);
  }, []);
  const { userAccess } = useUserAccess();

  useEffect(() => {
    fetchEfforts();
  }, [department.id]);

  const fetchEfforts = useCallback(async () => {
    try {
      const fetchedEfforts = await getEfforts(department.id);
      setEfforts(fetchedEfforts);
    } catch (err) {
      console.error("Failed to fetch efforts:", err);
    }
  }, [department.id]);

  const handleSaveEffort = async () => {
    if (newEffort.trim()) {
      try {
        await createEffort({
          departmentId: department.id,
          name: newEffort.trim(),
          triggerInvalidate: triggerInvalidate,
        });
        fetchEfforts();
        setNewEffort("");
      } catch (error) {
        console.error("Failed to create effort:", error);
      }
    }
  };

  useEffect(() => {
    if (invalidateKey === createEfforts) {
      fetchEfforts();
    }
    resetKey();
  }, [createEfforts, fetchEfforts, invalidateKey, resetKey]);

  const handleUpdateDepartment = async () => {
    if (editedName.trim() && editedName.trim() !== department.name) {
      try {
        const updatedDepartment = await updateDepartment(
          department.id,
          editedName.trim(),
          triggerInvalidate
        );
        if (onUpdateDepartment) {
          onUpdateDepartment(updatedDepartment);
        }
        setIsEditing(false);
      } catch (error) {
        console.error("Failed to update department:", error);
      }
    } else {
      setIsEditing(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        gap: "15px",
        width: "100%",
      }}
    >
      <Link
        className="nav-link"
        to={`/ambition/custom-action-plan/${department.name}/${year}/${department.id}`}
      >
        <div
          className="custom-action-plan-container"
          style={{ flexDirection: "column", height: "209px" }}
        >
          {isEditing && userAccess === "write" ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="text"
                value={editedName}
                onChange={(e) => setEditedName(e.target.value)}
                onBlur={handleUpdateDepartment}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleUpdateDepartment();
                  }
                }}
                autoFocus
                style={{
                  background: "transparent",
                  border: "none",
                  outline: "none",
                  color: "white",
                  fontSize: "inherit",
                  width: "100%",
                }}
              />
            </div>
          ) : (
            <div
              onClick={() => setIsEditing(true)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                gap: "33px",
              }}
            >
              <h5> {department.name}</h5>
              <img src={ambitionIcon} alt="Add icon" width={50} height={50} />
            </div>
          )}
        </div>
      </Link>
      <div style={{ display: "flex" }}>
        <CustomList
          className="custom-action-plan-container"
          newName={newEffort}
          setNewName={setNewEffort}
          handleSave={handleSaveEffort}
          efforts={efforts}
          link={`/ambition/custom-action-plan/${department.name}/${year}/${department.id}`}
        />
      </div>
    </div>
  );
};
